export default function getTelegramLinkVip(): string {
  return 'https://t.me/+DRw2b5SrAyUwZDQ0';
}
